"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailSchema = exports.AnimalSpeciesSchema = exports.SheepSpeciesSchema = exports.PoultrySpeciesSchema = exports.PigSpeciesSchema = exports.GoatSpeciesSchema = exports.CattleSpeciesSchema = exports.AustraliaBreedSchema = exports.DigirodeoBreedSchema = exports.AnimalCategorySchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
//Animal Category
exports.AnimalCategorySchema = zod_1.z.enum(["Heifer", "Calf", "Bull", "Cow", "Little Steers", "Veal", "Steers"]);
//Breed
exports.DigirodeoBreedSchema = zod_1.z.enum([
    "Angus",
    "Brahman",
    "Hereford",
    "Shorthorn",
    "Charolais",
    "Limousin",
    "Nelore",
    "Brangus",
    "Bradford",
    "Criollo",
    "Holando Argentino",
    "Jersey",
    "Senepol",
    "Simmental",
    "Holestein Friesian",
    "Overo Negro",
    "Overo Colorado",
    "Ayrshire",
    "Rojo Noruego",
    "JerHol",
    "Otra",
    "Careta"
]);
exports.AustraliaBreedSchema = zod_1.z.enum([
    "Angus",
    "Hereford",
    "Jersey",
    "Friesian",
    "Holestein",
    "Holestein Friesian",
]);
//Species
exports.CattleSpeciesSchema = zod_1.z.enum(['Beef', 'Dairy', 'Mixed']);
exports.GoatSpeciesSchema = zod_1.z.enum(['Fibre', 'Meat', 'Milk', 'Miniatures', 'Mutton Breed', 'Wool Breed']);
exports.PigSpeciesSchema = zod_1.z.enum(['Meat']);
exports.PoultrySpeciesSchema = zod_1.z.enum(['Chicken', 'Turkey', 'Meat']);
exports.SheepSpeciesSchema = zod_1.z.enum(['Dairy', 'Dual Purpose', 'Meat Breed', 'Shedding Sheep', 'Wool Breed']);
exports.AnimalSpeciesSchema = zod_1.z.union([exports.CattleSpeciesSchema, exports.GoatSpeciesSchema, exports.PigSpeciesSchema, exports.PoultrySpeciesSchema, exports.SheepSpeciesSchema]);
//Token Details
exports.AssetDetailSchema = zod_1.z.object({
    breed: zod_1.z.string().optional(),
    sex: zod_1.z.string().optional(),
    pic_id: zod_1.z.string().optional(),
    induction_weight: zod_1.z.number().optional(),
    induction_date: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).optional(),
    date_of_birth: zod_1.z.string().optional(),
    //others
    externalIds: TokenMisc.ExternalIdsSchema.optional(),
    category: exports.AnimalCategorySchema.optional(),
    pic_name: zod_1.z.string().optional(),
    pic_group_id: zod_1.z.string().optional(),
    pic_group_name: zod_1.z.string().optional(),
    species: zod_1.z.string().optional(),
    species_type: zod_1.z.string().optional(),
    weight_at_birth: zod_1.z.number().optional(),
    breed_type: zod_1.z.string().optional(),
    weight: zod_1.z.number().optional(),
    unit: zod_1.z.string().optional(),
    date_of_weight: zod_1.z.string().optional(),
    date_of_location: zod_1.z.string().optional(),
    location_lat: zod_1.z.number().optional(),
    location_long: zod_1.z.number().optional(),
    lot_id: zod_1.z.string().optional(),
    lot_name: zod_1.z.string().optional(),
    paddock_id: zod_1.z.string().optional(),
    paddock_name: zod_1.z.string().optional(),
    pen_id: zod_1.z.string().optional(),
    pen_name: zod_1.z.string().optional(),
    zone_id: zod_1.z.string().optional(),
    zone_name: zod_1.z.string().optional(),
    management_id: zod_1.z.string().optional(),
    management_name: zod_1.z.string().optional(),
    external_identify: zod_1.z.string().optional(),
    group: zod_1.z.array(zod_1.z.object({
        agliveToken: zod_1.z.string()
    })).optional(),
    //ceres tag 
    activityLevel: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
    observationDateUTC: zod_1.z.date().optional(),
    locationAccuracy: zod_1.z.number().optional(),
    temperature: zod_1.z.number().optional(),
    latitude: zod_1.z.number().optional(),
    longitude: zod_1.z.number().optional(),
    //warakirri
    visual_tag: zod_1.z.string().optional(),
    breeder_site: zod_1.z.string().optional(),
    genetic_sire: zod_1.z.string().optional(),
    genetic_dam: zod_1.z.string().optional(),
    birth_season: zod_1.z.string().optional(),
    birth_year: zod_1.z.number().optional()
});
